function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIconDM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/filled/application/bell",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "slnqgy6oaa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/application/bell (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/application/bell (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/filled/application/bell",
    style: {
      clipPath: "url(#slnqgy6oaa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/filled/application/bell (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/application/bell (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.239 18.959a2.416 2.416 0 0 1-2.413-2.413H.172A.172.172 0 0 1 0 16.374v-.69a.69.69 0 0 1 .689-.689h.517V7.67A6.033 6.033 0 0 1 6.377 1.7V.862a.862.862 0 0 1 1.723 0V1.7a6.033 6.033 0 0 1 5.172 5.97v7.325h.517a.69.69 0 0 1 .689.689v.69a.172.172 0 0 1-.172.172H9.652a2.416 2.416 0 0 1-2.413 2.413zM6.2 16.546a1.034 1.034 0 0 0 2.068 0z",
    transform: "translate(3.792 1.551)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIconDM);
export default __webpack_public_path__ + "static/media/bellIcon_d_m.8a034efb5c98a0cafb6c0fdb9ae7bc5a.svg";
export { ForwardRef as ReactComponent };